<div id="representative-detail-wrapper" data-cy="representative-detail-wrapper">
  <p *ngIf="notFound" data-cy="representative-not-found">Representative not found.</p>

  <p-card *ngIf="representative && !notFound" class="representative-form-card" data-cy="representative-form-card">
    <ng-template pTemplate="header">
      <div id="representative-form-card-header">
        <h1>{{ representative.NameFirst }} {{ representative.NameLast }}</h1>

        <ng-container *ngIf="(mode$ | async) === 'view'">
          <p-button
            (onClick)="edit()"
            icon="pi pi-file-edit"
            label="Edit"
            size="large"
            id="edit-representative-button"
            data-cy="edit-representative"
          ></p-button>
        </ng-container>
        <div *ngIf="(mode$ | async) === 'edit'" class="representative-form-card-header-edit-actions">
          <p-button
            (onClick)="cancelEdit()"
            [disabled]="isSaving"
            icon="pi pi-ban"
            label="Cancel"
            size="large"
            id="cancel-edit-representative-button"
            data-cy="cancel-edit-representative"
          ></p-button>
          <p-button
            (onClick)="saveRepresentative()"
            [disabled]="(isSaveDisabled$ | async) === true || isSaving"
            [loading]="isSaving"
            icon="pi pi-check-square"
            label="Save"
            size="large"
            id="save-representative-button"
            data-cy="save-representative"
          ></p-button>
        </div>
      </div>
    </ng-template>

    <app-representative-form></app-representative-form>

    <app-representative-merchants-card
      [representativeId]="representative.RepresentativeId"
      (merchantClicked)="viewMerchant($event)"
    ></app-representative-merchants-card>
  </p-card>
</div>
